export const WhaleLogo = ({ className = "w-10 h-10", flip = false }) => (
  <svg
    viewBox="0 0 64 64"
    className={className}
    style={flip ? { transform: "scaleX(-1)" } : undefined}
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M6 34C6 21 18 12 33 12c9 0 17 3.6 21.5 9.5L64 15c1.2 6 1 12-2.5 17 3.5 5 3.7 11 2.5 17l-9.5-6.5C50 48.4 42 52 33 52 18 52 6 47 6 34Z"
      fill="#38BDF8"
      stroke="#0F172A"
      strokeWidth="4.5"
      strokeLinejoin="round"
    />
    <path
      d="M14 40c8 6 30 6 40-2"
      stroke="#0F172A"
      strokeWidth="3.5"
      strokeLinecap="round"
      opacity="0.35"
    />
    <circle cx="19" cy="31" r="3.4" fill="#0F172A" />
    <circle cx="20.2" cy="29.8" r="1.1" fill="#fff" />
    <path
      d="M30 8c1.5-4.5 5-6.5 9-6"
      stroke="#0EA5E9"
      strokeWidth="4.5"
      strokeLinecap="round"
    />
  </svg>
);

export default WhaleLogo;
